const reducer = (
  state = {
    controlledUserDetails: {},
  },
  action,
) => {
  switch (action.type) {
    case 'CONTROLLED_USER_DETAILS_RECEIVED': {
      return {
        ...state,
        controlledUserDetails: action.data,
      };
    }
    case 'ALL_USER_LIST': {
      return {
        ...state,
        showShimmer: false,
        allUsersList: action.data,
      };
    }
    case 'USER_INVITE_STATUS': {
      return {
        ...state,
        inviteUserStatus: action.data,
      };
    }
    case 'RESET_INVITE_STATUS': {
      return {
        ...state,
        inviteUserStatus: false,
        inviteList: [],
      };
    }
    case 'SET_MERCHANT': {
      return {
        ...state,
        merchants: action.data,
      };
    }
    case 'EMPTY_USER_LIST': {
      return {
        ...state,
        allUsersList: null,
      };
    }
    case 'GET_USER_LIST': {
      return {
        showShimmer: true,
      };
    }
    case 'STORE_INVITE_LIST': {
      return {
        inviteList: action.data,
      };
    }
    case 'LIMIT_UPDATE_RES': {
      return {
        ...state,
        limitRes: action.data,
      };
    }
    case 'SET_CONTROLLED_USER': {
      return {
        ...state,
        userList: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
